var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5385 12.0769H71.3077C72.7944 12.0769 74 13.2823 74 14.7692V57.8462C74 59.3328 72.7944 60.5385 71.3077 60.5385H6.69231C5.20539 60.5385 4 59.3328 4 57.8462V14.7692C4 13.2823 5.20539 12.0769 6.69231 12.0769H17.4615M33.6154 60.5385L28.2308 74M44.3846 60.5385L49.7692 74M22.8462 74H55.1538M39 36.3077V4M39 4L28.2308 14.7692M39 4L49.7692 14.7692",
    stroke: "#00C389",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon2);
export default __webpack_public_path__ + "static/media/privacy_icon_2.38793cf0d3ad5874ee6e90d5ed4d1c9b.svg";
export { ForwardRef as ReactComponent };